const getBaseURL = () => {
    const currentHost = window.location.hostname; // Obtiene el host actual
    if (currentHost.startsWith('www.')) {
        return 'https://www.hamburguesa.johanstrujillop.com';
    } else {
        return 'https://hamburguesa.johanstrujillop.com';
    }
};

const baseURL = getBaseURL(); // Obtiene la URL base correcta

export default  baseURL;